// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"eee6e914","110":"f5e97f33","210":"31d6cfe0","352":"1472bd81","636":"5b0a518f","784":"fd0bff51","886":"989883fb","976":"f2b6813a"}[chunkId] + ".chunk.css";
};